import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tn-jiantou",
  "use": "icon-tn-jiantou-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tn-jiantou\"><path d=\"M785.464889 488.106667L274.545778 63.488C255.431111 47.786667 227.555556 62.008889 227.555556 87.381333v849.180445c0 25.486222 27.875556 39.708444 46.990222 23.893333l510.919111-424.561778a31.573333 31.573333 0 0 0 0-47.786666z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol